import React from 'react'
import bgApp from "./../Images/Desktop-2/moon-light.png";
import bgApp2 from "./../Images/Desktop-2/moon-light-shine-through-window-into-islamic-mosque-interior 1.jpg";
import { useLocation } from 'react-router-dom';

function BgApp() {
    const {pathname} = useLocation()
  return (
    <div>
      <img
        className="w-100 h-100 absolute z-0"
        src={pathname!=="/" ? bgApp : bgApp2}
        alt=""
      />
    </div>
  );
}

export default BgApp